import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { DatadogDashboardComponent } from '@app/features/datadog/modules/datadog-dashboard/datadog-dashboard.component';
import { HealthNavComponent } from '@app/shared/components/health-nav/health-nav.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        HealthNavComponent
    ],
    declarations: [
        DatadogDashboardComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class DatadogModule {}
